var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-btn',{staticClass:"reset-btn",attrs:{"fab":"","outlined":"","x-large":""},on:{"click":function($event){return _vm.handleClick()}}},[_c('v-icon',[_vm._v("mdi-arrow-right")])],1),(_vm.text && _vm.text.length)?_c('p',{staticClass:"mt-1"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }